var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.videoList),function(item,xh){return _c('div',{key:xh,staticClass:"video"},[_c('video',{attrs:{"src":item.playurl,"controls":"","muted":"","preload":""},domProps:{"muted":true}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }